<template>
    <div>
      <br>
      <GmapMap
      :center="LatLngDetails"
      :zoom='13'
      style='width:100%;  height: 400px;'
    />
    </div>
  </template>
  
  <script>
  export default {
    name: 'GoogleMap',
  props: {
    LatLngDetails: {},
  },
  }
  </script>